module.exports = __webpack_public_path__ + "img/c1a2699.png";